import { render } from "./SceneProperty.vue?vue&type=template&id=716e0ac8&scoped=true"
import script from "./SceneProperty.vue?vue&type=script&lang=js"
export * from "./SceneProperty.vue?vue&type=script&lang=js"

import "./SceneProperty.vue?vue&type=style&index=0&id=716e0ac8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716e0ac8"]])

export default __exports__